import saveToBraze from "@utils/brazeUploader";
import { getMeristemExperimentsString } from "@utils/experiment";
import { getRouteId } from "@utils/meristemContext";

export async function submitSupporterEmail(
  userEmail: string,
  userName: string,
  supporterEmail: string,
  extraEventParams: Record<string, any> = {}
) {
  const isOwnEmail =
    userEmail?.trim().toLowerCase() === supporterEmail.trim().toLowerCase();

  const eventParams: Record<string, any> = {
    name: userName,
    user_email: userEmail,
    supporter_email: supporterEmail,
    isOwnEmail,
    routeId: getRouteId(),
    experiment: "baseline",
    experiments: getMeristemExperimentsString(),
  };

  await saveToBraze({
    event: {
      event_name: "SubmittedSupporterPlanEmail",
      event_data: { ...eventParams, ...extraEventParams },
    },
  });
}
